import { useState } from "react";

export function useFocusBlur(wrapped?: {
  onFocus?: () => void;
  onBlur?: () => void;
}) {
  const [isFocused, setIsFocused] = useState(false);

  return {
    isFocused,
    controlFocus: {
      onFocus: () => {
        setIsFocused(true);
      },
      onBlur: () => {
        wrapped && wrapped.onBlur && wrapped.onBlur();
        setIsFocused(false);
      },
    },
  };
}
